import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPEnergyAuditPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveWorkEnergyAuditSlice';
import moment from 'moment'

export default function STPEnergyAuditDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [EnergyAuditTextField, setEnergyAuditTextField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        stipElectricConsumption: Flag === 'Update' ? rowData.stipElectricConsumption : '',
        consumptionKWH: Flag === 'Update' ? rowData.consumptionKWH : '',
        powerFactor: Flag === 'Update' ? rowData.powerFactor : '',
        powerFactorIncentive: Flag === 'Update' ? rowData.powerFactorIncentive : '',
        demandPenalty: Flag === 'Update' ? rowData.demandPenalty : '',
    })

    const handleEnergyAuditTextField = (e) => {
        setEnergyAuditTextField({ ...EnergyAuditTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_STP_EnergyAuditID: Flag === 'Update' ? rowData.t_stP_EnergyAuditID : '0',
            StipElectricConsumption: EnergyAuditTextField.stipElectricConsumption,
            ConsumptionKWH: EnergyAuditTextField.consumptionKWH,
            PowerFactor: EnergyAuditTextField.powerFactor,
            PowerFactorIncentive: EnergyAuditTextField.powerFactorIncentive,
            DemandPenalty: EnergyAuditTextField.demandPenalty,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(STPEnergyAuditPostDataAPI({ data }))
    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Energy Audit</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Reading Date</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="readingDate"
                                            name='readingDate'
                                            value={EnergyAuditTextField.readingDate}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Stip Electric Consumptions</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="stipElectricConsumption"
                                            name='stipElectricConsumption'
                                            value={EnergyAuditTextField.stipElectricConsumption}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Consumption KWH</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="consumptionKWH"
                                            name='consumptionKWH'
                                            value={EnergyAuditTextField.consumptionKWH}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Power Factor</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="powerFactor"
                                            name='powerFactor'
                                            value={EnergyAuditTextField.powerFactor}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Power Factor Incentives</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="powerFactorIncentive"
                                            name='powerFactorIncentive'
                                            value={EnergyAuditTextField.powerFactorIncentive}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Demand Penalty</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="demandPenalty"
                                            name='demandPenalty'
                                            value={EnergyAuditTextField.demandPenalty}
                                            onChange={(e) => handleEnergyAuditTextField(e)}
                                        />

                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={EnergyAuditTextField.readingDate == '' || EnergyAuditTextField.stipElectricConsumption == '' || EnergyAuditTextField.consumptionKWH == ''
                                            || EnergyAuditTextField.powerFactor == '' || EnergyAuditTextField.powerFactorIncentive == '' || EnergyAuditTextField.demandPenalty == ''}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}